<template>
  <div class="about content">
    <div class="left-side slideUp">
      <div class="left-container">
          <h2>Contáctame</h2>
          <p>Puedes ponerte en contacto conmigo por: </p>
          <a
          target="_blank"
          href="https://www.linkedin.com/in/nicole-loupias/"
          ><font-awesome-icon :icon="['fab', 'linkedin']" size="2x" /> Linkedin</a
        >
        <a
          target="_blank"
          href="https://github.com/nicoleloupias"
          ><font-awesome-icon :icon="['fab', 'github']" size="2x" /> Github</a
        >
        <a
          target="_blank"
          href="https://twitter.com/NicoleCoding"
          ><font-awesome-icon :icon="['fab', 'twitter']" size="2x" /> Twitter</a
        >
        <a
          href="mailto:loupiasnicole@gmail.com"
          ><font-awesome-icon icon="envelope" size="2x" /> Correo</a
        >
      </div>
    </div>

    <div class="imgContact right-side">
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact"
};
</script>

<style lang="scss" scoped>

.left-side {
    justify-content: center;

    a {
        display: flex;
        align-items: center;
        color: #3F3D56;

        svg {
            margin: 5px;
            color:#F44647;
        }
    }
    .left-container {
      margin: auto;
      width: auto;
    }
}
.right-side {
    background-color: white !important;

    &.imgContact {
      background: url("../assets/contact.svg");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;


      @media screen and (max-width: 1000px) {
        background-size: contain;
        height: 300px;
        width: 100%;

      }
  }
}



</style>
